import {ModuleWithProviders} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {PlatformCentralAuth} from './authFilter/platformCentralAuth';

import {ApiComponent} from './api/api.component';
import {AddComponent} from './api/add/add.component';
import {CloudInfrastructureComponent} from './common-data-api/cloud-infrastructure/cloud-infrastructure.component';
import {ComputerNetworksComponent} from './common-data-api/computer-networks/computer-networks.component';
import {DatabaseComponent} from './common-data-api/database/database.component';
import {DetailCdaComponent} from './common-data-api/detail-cda/detail-cda.component';
import {EducationComponent} from './common-data-api/education/education.component';
import {GeoComponent} from './common-data-api/geo/geo.component';
import {LocalesComponent} from './common-data-api/locales/locales.component';
import {TalentManagementComponent} from './common-data-api/talent-management/talent-management.component';
import {EditComponent} from './api/edit/edit.component';
import {InfoComponent} from './api/info/info.component';
import {ImportComponent} from './api/import/import.component';
import {CrudapiComponent} from './crudapi/crudapi.component';
import {PartnerOnboardComponent} from './partner-onboard/partner-onboard.component';
import {HomeOldComponent} from './home-old/home-old.component';
import {ManageEntitiesComponent} from './manage-entities/manage-entities.component';
import {LoginComponent} from './login/login.component';
import {SignupComponent} from './signup/signup.component';
import {EditEntityComponent} from './edit-entity/edit-entity.component';
import {PlansComponent} from './plans/plans.component';
import {FileStoreComponent} from './file-store/file-store.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {LegalDocsComponent} from './legal-docs/legal-docs.component';
import {QueryBuilderComponent} from './query-builder/query-builder.component';
import {CustomoperationComponent} from './customoperation/customoperation.component';
import {EditorComponent} from './query-builder/editor/editor.component';
import {CommonDataApiComponent} from './common-data-api/common-data-api.component';
import {MetricsDashboardComponent} from './metrics-dashboard/metrics-dashboard.component';
import {SignUpComponent} from './sign-up/sign-up.component';
import {DigitalTransformerComponent} from './digital-transformer/digital-transformer.component';
import {DevexComponent} from './devex/devex.component';
import {ApimanagementComponent} from './apimanagement/apimanagement.component';
import {ManageRolesComponent} from './manage-roles/manage-roles.component';
import {PermissionGroupsComponent} from './permission-groups/permission-groups.component';
import {UserManagementComponent} from './user-management/user-management.component';
import {FabricatorComponent} from './fabricator/fabricator.component';
import {CreatefromopenapiComponent} from './createfromopenapi/createfromopenapi.component';
import {NewBlocklyComponent} from './new-blockly/new-blockly.component';
import {BusinessLogicApiListComponent} from './business-logic-api-list/business-logic-api-list.component';
import {DashboardContainerComponent} from './container/dashboard-container/dashboard-container.component';
import {HomeComponent} from './components/home/home.component';
import {AuthContainerComponent} from './container/auth-container/auth-container.component';
import {FaqComponent} from './components/about-us/faq/faq.component';
import {BillingComponent} from './billing/billing.component';
import {GatewayComponent} from './gateway/gateway.component';
import {MasterPluginComponent} from './master-plugin/master-plugin.component';
import {SettingsComponent} from './settings/settings.component';
import {BusinessdetailsComponent} from './settings/businessdetails/businessdetails.component';
import {BusinesslocationsComponent} from './settings/businesslocations/businesslocations.component';
import {CreditsComponent} from './settings/credits/credits.component';
import {BrandingComponent} from './settings/branding/branding.component';
import {DatabasesComponent} from './settings/databases/databases.component';
import {IdentitymanagerComponent} from './settings/identitymanager/identitymanager.component';
import {IpconfigComponent} from './settings/ipconfig/ipconfig.component';
import {CategoriesComponent} from './settings/categories/categories.component';
import {ApiKeyComponent} from './settings/api-key/api-key.component';
import {DashboardComponent} from './settings/dashboard/dashboard.component';
import {AccountsComponent} from './settings/accounts/accounts.component';
import {MetricsSettingsComponent} from './settings/metrics-settings/metrics-settings.component';
import {QueryBuilderBaseComponent} from './query-builder-base/query-builder-base.component';
import {ResumeParserComponent} from './resume-parser/resume-parser.component';
import {BpmnComponent} from './bpmn/bpmn.component';
import {ProcessInstanceComponent} from './bpmn/process-instance/process-instance.component';
import {EmailtemplatebuilderComponent} from './emailtemplatebuilder/emailtemplatebuilder.component';
import {ExecuteemailtemplateComponent} from './executeemailtemplate/executeemailtemplate.component';
import {DmnComponent} from './dmn/dmn.component';
import {CampaignManagerComponent} from './campaign-manager/campaign-manager.component';
import {LandingPageComponent} from './landing-page/landing-page.component';
import {ViewerComponent} from './devex/viewer/viewer.component';
import {AddEnvironmentComponent} from './settings/environment-settings/add-environment/add-environment.component';
import {DocumentorComponent} from './documentor/documentor.component';
import {AudienceSettingsComponent} from './settings/audience-settings/audience-settings.component';
import {AuthorizationsSettingsComponent} from './settings/authorizations-settings/authorizations-settings.component';
import {CampaignSettingsComponent} from './settings/campaign-settings/campaign-settings.component';
import {ComplianceSettingsComponent} from './settings/compliance-settings/compliance-settings.component';
import {ConnectorsSettingsComponent} from './settings/connectors-settings/connectors-settings.component';
import {CouponManagementSettingsComponent} from './settings/coupon-management-settings/coupon-management-settings.component';
import {EmailSettingsComponent} from './settings/email-settings/email-settings.component';
import {EncryptionSettingsComponent} from './settings/encryption-settings/encryption-settings.component';
import {PermissionGroupSettingsComponent} from './settings/permission-group-settings/permission-group-settings.component';
import {PermissionSettingsComponent} from './settings/permission-settings/permission-settings.component';
import {RolesSettingsComponent} from './settings/roles-settings/roles-settings.component';
import {SourceControlManagementSettingsComponent} from './settings/source-control-management-settings/source-control-management-settings.component';
import {UserGroupsSettingsComponent} from './settings/user-groups-settings/user-groups-settings.component';
import {UsersSettingsComponent} from './settings/users-settings/users-settings.component';
import {ApiRegistrarSettingsComponent} from './settings/api-registrar-settings/api-registrar-settings.component';
import {BotSettingsComponent} from './settings/bot-settings/bot-settings.component';
import {CodeGenSettingsComponent} from './settings/code-gen-settings/code-gen-settings.component';
import {GrRateLimitingSettingsComponent} from './settings/gr-rate-limiting-settings/gr-rate-limiting-settings.component';
import {GtCorsSettingsComponent} from './settings/gt-cors-settings/gt-cors-settings.component';
import {GtIpSettingsComponent} from './settings/gt-ip-settings/gt-ip-settings.component';
import {IntegrationLanguagesSettingsComponent} from './settings/integration-languages-settings/integration-languages-settings.component';
import {IntegratorSettingsComponent} from './settings/integrator-settings/integrator-settings.component';
import {ServiceProvidersSettingsComponent} from './settings/service-providers-settings/service-providers-settings.component';
import {ServicesSettingsComponent} from './settings/services-settings/services-settings.component';
import {SubscriptionSettingsComponent} from './settings/subscription-settings/subscription-settings.component';
import {ThemesSettingsComponent} from './settings/themes-settings/themes-settings.component';
import {TransformationApiSettingsComponent} from './settings/transformation-api-settings/transformation-api-settings.component';
import {TransformationCobolSettingsComponent} from './settings/transformation-cobol-settings/transformation-cobol-settings.component';
import {TransformationDatabaseSettingsComponent} from './settings/transformation-database-settings/transformation-database-settings.component';
import {DevexSettingsComponent} from './settings/devex-settings/devex-settings.component';
import {SecuritySettingsComponent} from './settings/security-settings/security-settings.component';
import {BillingSettingsComponent} from './settings/billing-settings/billing-settings.component';
import {CloudPlatformSettingsComponent} from './settings/cloud-platform-settings/cloud-platform-settings.component';
import {EnvironmentSettingsComponent} from './settings/environment-settings/environment-settings.component';
import {ApiGatewaySettingsComponent} from './settings/api-gateway-settings/api-gateway-settings.component';
import {DatabaseInfSettingsComponent} from './settings/database-inf-settings/database-inf-settings.component';
import {LoggingSettingsComponent} from './settings/logging-settings/logging-settings.component';
import {FileSettingsComponent} from './settings/file-settings/file-settings.component';
import {IdentitySettingsComponent} from './settings/identity-settings/identity-settings.component';
import {TrafficSettingsComponent} from './settings/traffic-settings/traffic-settings.component';
import {ConnectorsComponent} from './settings/connectors/connectors.component';
import {IntegrationsComponent} from './settings/integrations/integrations.component';
import {CategoryComponent} from './settings/category/category.component';
import {ProviderCategoryComponent} from './settings/provider-category/provider-category.component';
import {DocsComponent} from './docs/docs.component';
import {DocumentationComponent} from './documentation/documentation.component';
import {DocseditorComponent} from './docseditor/docseditor.component';
import {CollectionsComponent} from './settings/collections/collections.component';
import {ManageemailtemplatesComponent} from './manageemailtemplates/manageemailtemplates.component';
import {CobolToApiComponent} from './cobol-to-api/cobol-to-api.component';
import {SamplesComponent} from './samples/samples.component';
import {UxbuilderComponent} from './uxbuilder/uxbuilder.component';
import {PromotionComponent} from './promotion/promotion.component';
import {JsontoapiComponent} from './jsontoapi/jsontoapi.component';
import {ApitoapiComponent} from './apitoapi/apitoapi.component';
import {ConnectorlistComponent} from './connectorlist/connectorlist.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {ApiManagerComponent} from './api-manager/api-manager.component';
import {DaasCreatorComponent} from './daas-creator/daas-creator.component';
import {CreateComponent} from './components/home/create/create.component';
import {CrudapiAdvancedComponent} from './crudapi-advanced/crudapi-advanced.component';
import {EditEntityAdvancedComponent} from './edit-entity-advanced/edit-entity-advanced.component';
// import {IdleTimeoutComponent} from './settings/idle-timeout/idle-timeout.component';
import {ManageUsersComponent} from './admin/manage-users/manage-users.component';
import {ManageUserGroupsNewComponent} from './admin/manage-user-groups-new/manage-user-groups-new.component';
import {ManageScheduledJobsComponent} from './manage-scheduled-jobs/manage-scheduled-jobs.component';
import {DataCatalogueParentComponent} from './data-catalogue-parent/data-catalogue-parent.component';
import {TestsuiteComponent} from './testsuite/testsuite.component';
import {GatewayConsumerComponent} from './gateway-consumer/gateway-consumer.component';
import {AdminDashboardComponent} from './admin-dashboard/admin-dashboard.component';
import {UserVerificationComponent} from './manage-users1/user-verification/user-verification.component';
import {ManageUsers1Component} from './manage-users1/manage-users1.component';
import {ManageUserGroupsComponent} from './manage-user-groups/manage-user-groups.component';
import {BulkscriptsComponent} from './bulkscripts/bulkscripts.component';
import {AuthenticatorComponent} from './authenticator/authenticator.component';
import {ApiRegisterComponent} from './api-register/api-register.component';
import {MenuListComponent} from './menu-list/menu-list.component';
import {LearnComponent} from './learn/learn.component';
import {JourneyAnalyticsComponent} from './journey-analytics/journey-analytics.component';
import {ApiDependenciesComponent} from './api-dependencies/api-dependencies.component';
import {ApiDiscoveryComponent} from './api-discovery/api-discovery.component';
import {TestResultsComponent} from './testsuite/test-results/test-results.component';
import {PlSqlBaseComponent} from './pl-sql-base/pl-sql-base.component';
import {DeveloperExperienceComponent} from './developer-experience/developer-experience.component';
import {ApiqlEngineComponent} from './apiql-engine/apiql-engine.component';
import {DataqlEngineComponent} from './dataql-engine/dataql-engine.component';
import {PostmanCollectionsComponent} from './postman-collections/postman-collections.component';
import {ManageAutomationComponent} from './manage-automation/manage-automation.component';
import {TestResultsDashboardComponent} from './testsuite/test-results-dashboard/automation-dashboard.component';
import {ApiTestsuiteEditorComponent} from './api-testsuite-editor/api-testsuite-editor.component';
import {CollectionComponent} from './collection/collection.component';
import {DashboardMetricsComponent} from './dashboard-metrics/dashboard-metrics.component';
import {AcceleratorsComponent} from './accelerators/accelerators.component';
import {ViewAcceleratorCategoryComponent} from './accelerators/view-accelerator-category/view-accelerator-category.component';
import {AlertSettingsComponent} from './alert-settings/alert-settings.component';
import {MonitoringDashboardComponent} from './monitoring-dashboard/monitoring-dashboard.component';
import {ConsoleComponent} from './console/console.component';
import {TransformationPlanComponent} from './transformation-plan/transformation-plan.component';
import {ManageTriggerComponent} from './manage-trigger/manage-trigger.component';
import {SignupConfigurationsComponent} from './signup/signup-configurations/signup-configurations.component';
import {OnboardPartnerComponent} from './signup/onboard-partner/onboard-partner.component';
import {DataViewerComponent} from './api-joins/data-viewer/data-viewer.component';
import {ApprovalPageComponent} from './query-builder/approval-page/approval-page.component';
import {PlatformConsoleNewComponent} from './admin/platform-console-new/platform-console-new.component';
import {DeveloperSettingsNewComponent} from './admin/developer-settings-new/developer-settings-new.component';
import {FileStorageNewComponent} from './admin/file-storage-new/file-storage-new.component';
import {AdminConsumersComponent} from './admin/admin-consumers/admin-consumers.component';
import {ApiGatewaySettingsNewComponent} from './admin/api-gateway-settings-new/api-gateway-settings-new.component';
import {DatabasesNewComponent} from './admin/databases-new/databases-new.component';

import {S3ConnectorsNewComponent} from './admin/s3-connectors-new/s3-connectors-new.component';
import {EmailSettingsNewComponent} from './admin/email-settings-new/email-settings-new.component';
import {AuthorizationTypesNewComponent} from './admin/authorization-types-new/authorization-types-new.component';
import {EnvironmentsNewComponent} from './admin/environments-new/environments-new.component';

import {AdminGatewaySettingsComponent} from './admin/admin-gateway-settings/admin-gateway-settings.component';
import {IdleTimeoutNewComponent} from './idle-timeout-new/idle-timeout-new.component';
import {IdleTimeoutComponent} from './settings/idle-timeout/idle-timeout.component';
import {CognitiveSearchComponent} from './cognitive-search/cognitive-search.component';
import {CognitiveSearchNewComponent} from './cognitive-search-new/cognitive-search-new.component';
import {DataAnalyticsComponent} from './data-analytics/data-analytics.component';
import {DataAnalyticsNewComponent} from './data-analytics-new/data-analytics-new.component';
import { DataTransformationComponent } from './data-transformation/data-transformation.component';
import { DataTransformationHistoryComponent } from './data-transformation-history/data-transformation-history.component';
import {DataTransformationListComponent} from './data-transformation-list/data-transformation-list.component';
import {DataTransformationResultComponent} from './data-transformation-result/data-transformation-result.component';

const routes: Routes = [

    // {path: '', component: LandingPageComponent, canActivate: [PlatformCentralAuth]},
    {path: 'signup', component: OnboardPartnerComponent},
    {path: 'signup/configuration', component: SignupConfigurationsComponent},
    {path: 'learn', component: LearnComponent},
    {path: 'jsontoapi', component: JsontoapiComponent},
    {path: 'apitoapi', component: ApitoapiComponent},
    {path: 'connectorlist', component: ConnectorlistComponent, canActivate: [PlatformCentralAuth]},
    {path: 'dataaccessapi', component: CrudapiComponent, canActivate: [PlatformCentralAuth]},
    {path: 'dataaccessapi-advanced', component: CrudapiAdvancedComponent, canActivate: [PlatformCentralAuth]},
    {path: 'uxbuilder', component: UxbuilderComponent, canActivate: [PlatformCentralAuth]},
    /*{path: 'login', component: LoginComponent},*/
    {path: 'masterPlugin', component: MasterPluginComponent},
    {path: 'billing', component: BillingComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api', component: ApiComponent, canActivate: [PlatformCentralAuth]},
    {path: 'joinsrequest', component: ApprovalPageComponent},
    {path: 'apijoins', component: DataViewerComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api/add', component: AddComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api/import', component: ImportComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api/edit/:id', component: EditComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api/info/:id', component: InfoComponent, canActivate: [PlatformCentralAuth]},
    // {path: 'entity/edit', component: EditEntityComponent, canActivate: [PlatformCentralAuth]},
    {path: 'entity/edit', component: EditEntityAdvancedComponent, canActivate: [PlatformCentralAuth]},
    {path: 'controlplane', component: ManageEntitiesComponent, canActivate: [PlatformCentralAuth]},
    {path: 'metrics-dashboard', component: MetricsDashboardComponent, canActivate: [PlatformCentralAuth]},
    {path: 'resetpassword', component: ResetPasswordComponent},
    /*{path: 'plans', component: PlansComponent},*/
    {path: 'legal', component: LegalDocsComponent},
    {path: 'fabricator', component: NewBlocklyComponent, canActivate: [PlatformCentralAuth]},
    {path: 'sign-up', component: SignUpComponent},
    {path: 'common-data-api', component: CommonDataApiComponent},
    {path: 'gateway', component: GatewayComponent, canActivate: [PlatformCentralAuth]},
    {path: 'unified-query-builder', component: QueryBuilderComponent, canActivate: [PlatformCentralAuth]},
    {path: 'transform', component: TransformationPlanComponent, canActivate: [PlatformCentralAuth]},
    {path: 'roles', component: ManageRolesComponent, canActivate: [PlatformCentralAuth]},
    {path: 'permissiongroup', component: PermissionGroupsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'assign-roles', component: UserManagementComponent, canActivate: [PlatformCentralAuth]},
    // {path: 'fabricator', component: FabricatorComponent, canActivate: [PlatformCentralAuth]},
    {path: 'customoperation', component: CustomoperationComponent, canActivate: [PlatformCentralAuth]},
    {path: 'querybuilder/editor', component: EditorComponent, canActivate: [PlatformCentralAuth]},
    {path: 'filestorage', component: FileStoreComponent, canActivate: [PlatformCentralAuth]},
    {path: 'my-account', component: PartnerOnboardComponent, canActivate: [PlatformCentralAuth]},
    {path: 'digital-transformer', component: DigitalTransformerComponent, canActivate: [PlatformCentralAuth]},
    {path: 'devex', component: DeveloperExperienceComponent, canActivate: [PlatformCentralAuth]},
    {path: 'apimanagement', component: ApimanagementComponent, canActivate: [PlatformCentralAuth]},
    {path: 'application', component: CreatefromopenapiComponent, canActivate: [PlatformCentralAuth]},
    {path: 'application/edit', component: CreatefromopenapiComponent, canActivate: [PlatformCentralAuth]},
    {path: 'buslogic', component: BusinessLogicApiListComponent, canActivate: [PlatformCentralAuth]},
    {path: 'businesslogic', component: NewBlocklyComponent, canActivate: [PlatformCentralAuth]},
    {path: 'businesslogic/edit', component: NewBlocklyComponent, canActivate: [PlatformCentralAuth]},
    {path: 'common-data-api/cloud-infrastructure', component: CloudInfrastructureComponent, canActivate: [PlatformCentralAuth]},
    {path: 'collections', component: CollectionsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'common-data-api/computer-networks', component: ComputerNetworksComponent, canActivate: [PlatformCentralAuth]},
    {path: 'common-data-api/database', component: DatabaseComponent, canActivate: [PlatformCentralAuth]},
    {path: 'add-environment', component: AddEnvironmentComponent, canActivate: [PlatformCentralAuth]},
    {path: 'common-data-api/detail-cda', component: DetailCdaComponent, canActivate: [PlatformCentralAuth]},
    {path: 'common-data-api/education', component: EducationComponent, canActivate: [PlatformCentralAuth]},
    {path: 'common-data-api/geo', component: GeoComponent, canActivate: [PlatformCentralAuth]},
    {path: 'common-data-api/locales', component: LocalesComponent, canActivate: [PlatformCentralAuth]},
    {path: 'common-data-api/talent-management', component: TalentManagementComponent, canActivate: [PlatformCentralAuth]},
    {path: 'businessdetails', component: BusinessdetailsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'businesslocations', component: BusinesslocationsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'documentor', component: DocumentorComponent, canActivate: [PlatformCentralAuth]},
    {path: 'branding', component: BrandingComponent, canActivate: [PlatformCentralAuth]},
    {path: 'databases', component: DatabasesComponent, canActivate: [PlatformCentralAuth]},
    {path: 'identitymanager', component: IdentitymanagerComponent, canActivate: [PlatformCentralAuth]},
    {path: 'ipconfig', component: IpconfigComponent, canActivate: [PlatformCentralAuth]},
    {path: 'categories', component: CategoriesComponent, canActivate: [PlatformCentralAuth]},
    {path: 'category', component: CategoryComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api-management', component: ApiRegistrarSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'bot-settings', component: BotSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'security-settings', component: SecuritySettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'billing-settings', component: BillingSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'services-settings', component: ServicesSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'devex-settings', component: DevexSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'code-gen-settings', component: CodeGenSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'gr-rate-limiting-settings', component: GrRateLimitingSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'gt-cors-settings', component: GtCorsSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'gt-ip-settings', component: GtIpSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'integration-languages-settings', component: IntegrationLanguagesSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'integrator-settings', component: IntegratorSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'service-providers-settings', component: ServiceProvidersSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'service-settings', component: ServicesSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'subscription-settings', component: SubscriptionSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'themes-settings', component: ThemesSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'transformation-api-settings', component: TransformationApiSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'transformation-cobol-settings', component: TransformationCobolSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'docs', component: DocsComponent},
    {path: 'documentation', component: DocumentationComponent},
    {path: 'provider-category', component: ProviderCategoryComponent, canActivate: [PlatformCentralAuth]},
    {path: 'docseditor', component: DocseditorComponent, canActivate: [PlatformCentralAuth]},
    {path: 'transformation-database-settings', component: TransformationDatabaseSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'metrics-settings', component: MetricsSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'dashboard-metrics', component: DashboardMetricsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'monitors', component: MonitoringDashboardComponent, canActivate: [PlatformCentralAuth]},
    {path: 'audience-settings', component: AudienceSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'cloud-platform', component: CloudPlatformSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'environments', component: EnvironmentSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api-gateway', component: ApiGatewaySettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'database-inf-settings', component: DatabaseInfSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'secrets-manager', component: LoggingSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'file-settings', component: FileSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'identity-settings', component: IdentitySettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'traffic-settings', component: TrafficSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'testsuite', component: TestsuiteComponent, canActivate: [PlatformCentralAuth]},
    {path: 'authorizations-settings', component: AuthorizationsSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'campaign-settings', component: CampaignSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'compliance-settings', component: ComplianceSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'connectors-settings', component: ConnectorsSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'coupon-management', component: CouponManagementSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'email-settings', component: EmailSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'encryption-settings', component: EncryptionSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'permission-group-settings', component: PermissionSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'permission-settings', component: PermissionSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'roles-settings', component: RolesSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'source-control-management-settings', component: SourceControlManagementSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'user-groups-settings', component: UserGroupsSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'users-settings', component: UsersSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api-key', component: ApiKeyComponent, canActivate: [PlatformCentralAuth]},
    {path: 'dashboard', component: DashboardComponent, canActivate: [PlatformCentralAuth]},
    {path: 'accounts', component: AccountsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'credits', component: CreditsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'querybuilder', component: QueryBuilderBaseComponent, canActivate: [PlatformCentralAuth]},
    {path: 'data-transform', component: DataTransformationComponent, canActivate: [PlatformCentralAuth]},
    {path: 'data-transform/result/:transformationPlanId', component: DataTransformationResultComponent, canActivate: [PlatformCentralAuth]},
    {path: 'parser', component: ResumeParserComponent, canActivate: [PlatformCentralAuth]},
    {path: 'workflow', component: BpmnComponent, canActivate: [PlatformCentralAuth]},
    {path: 'dmn', component: DmnComponent, canActivate: [PlatformCentralAuth]},
    {path: 'workflow/processInstance', component: ProcessInstanceComponent, canActivate: [PlatformCentralAuth]},
    {path: 'emailtemplatebuilder', component: EmailtemplatebuilderComponent, canActivate: [PlatformCentralAuth]},
    {path: 'executeemailtemplate', component: ExecuteemailtemplateComponent, canActivate: [PlatformCentralAuth]},
    {path: 'campaignmanager', component: CampaignManagerComponent},
    {path: 'console', component: LandingPageComponent, canActivate: [PlatformCentralAuth]},
    {path: 'connectors', component: ConnectorsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'providers', component: IntegrationsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'devex/viewer', component: ViewerComponent},
    {path: 'email-templates', component: ManageemailtemplatesComponent, canActivate: [PlatformCentralAuth]},
    {path: 'coboltoapi', component: CobolToApiComponent, canActivate: [PlatformCentralAuth]},
    {path: 'samples', component: SamplesComponent, canActivate: [PlatformCentralAuth]},
    {path: 'promotion', component: PromotionComponent, canActivate: [PlatformCentralAuth]},
    // {path: 'administration', component: EnvironmentSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'administration/:environment', component: EnvironmentSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'administration/:environment/:subcategory', component: EnvironmentSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api-manager', component: ApiManagerComponent, canActivate: [PlatformCentralAuth]},
    {path: 'daas-creator', component: DaasCreatorComponent, canActivate: [PlatformCentralAuth]},
    {path: 'idle-timeout', component: IdleTimeoutComponent, canActivate: [PlatformCentralAuth]},

    {path: 'scheduler', component: ManageScheduledJobsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'trigger', component: ManageTriggerComponent, canActivate: [PlatformCentralAuth]},
    {path: 'datacatalog', component: DataCatalogueParentComponent, canActivate: [PlatformCentralAuth]},
    {path: 'consumer', component: GatewayConsumerComponent, canActivate: [PlatformCentralAuth]},
    {path: 'admin-dashboard', component: AdminDashboardComponent},
    {path: 'users-management', component: ManageUsers1Component, canActivate: [PlatformCentralAuth]},
    {path: 'verifyuser', component: UserVerificationComponent},
    {path: 'user-group', component: ManageUserGroupsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'bulkscripts', component: BulkscriptsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api-register', component: ApiRegisterComponent, canActivate: [PlatformCentralAuth]},
    {path: 'journey', component: JourneyAnalyticsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'discover', component: ApiDiscoveryComponent, canActivate: [PlatformCentralAuth]},
    {path: 'test-results', component: TestResultsDashboardComponent, canActivate: [PlatformCentralAuth]},
    {path: 'test-results/:submenu', component: TestResultsDashboardComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api-testsuite', component: ApiTestsuiteEditorComponent, canActivate: [PlatformCentralAuth]},
    {path: 'plsql', component: PlSqlBaseComponent, canActivate: [PlatformCentralAuth]},
    {path: 'authenticator', component: AuthenticatorComponent},
    {path: 'menu', component: MenuListComponent},
    {path: 'api-dependencies', component: ApiDependenciesComponent, canActivate: [PlatformCentralAuth]},
    {path: 'apiql', component: ApiqlEngineComponent, canActivate: [PlatformCentralAuth]},
    {path: 'dataql', component: DataqlEngineComponent, canActivate: [PlatformCentralAuth]},
    {path: 'postman-collections', component: PostmanCollectionsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'collection', component: CollectionComponent, canActivate: [PlatformCentralAuth]},
    {path: 'alerts', component: AlertSettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'accelerators', component: AcceleratorsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'accelerator', redirectTo: '/accelerators', pathMatch: 'full'},
    {path: 'accelerator/:integration_id', component: ViewAcceleratorCategoryComponent, canActivate: [PlatformCentralAuth]},
    {path: 'accelerator/:integration_id/api/:accelerator_id', component: ViewAcceleratorCategoryComponent, canActivate: [PlatformCentralAuth]},
    {path: 'users', component: ManageUsersComponent, canActivate: [PlatformCentralAuth]},
    {path: 'user-groups', component: ManageUserGroupsNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'idletimeout', component: IdleTimeoutNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'platform-console', component: PlatformConsoleNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'dev-ex', component: DeveloperSettingsNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'file-storage', component: FileStorageNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'consumers', component: AdminConsumersComponent, canActivate: [PlatformCentralAuth]},
    {path: 'api-gateway-settings', component: ApiGatewaySettingsNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 's3-connectors', component: S3ConnectorsNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'email-setting', component: EmailSettingsNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'admin-auth-types', component: AuthorizationTypesNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'dev-environments', component: EnvironmentsNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'data-bases', component: DatabasesNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'gateway-settings', component: AdminGatewaySettingsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'cognitive-search', component: CognitiveSearchComponent, canActivate: [PlatformCentralAuth]},
    {path: 'cognitive-search-new', component: CognitiveSearchNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'data-analytics', component: DataAnalyticsComponent, canActivate: [PlatformCentralAuth]},
    {path: 'data-analytics-new', component: DataAnalyticsNewComponent, canActivate: [PlatformCentralAuth]},
    {path: 'data-transform-history', component: DataTransformationHistoryComponent, canActivate: [PlatformCentralAuth]},
    {path: 'data-transform-plans', component: DataTransformationListComponent, canActivate: [PlatformCentralAuth]},


    // {path: 'faq', component: FaqComponent},
    {
        path: 'auth',
        // component: (!localStorage.getItem('Auth') ? AuthContainerComponent : ManageEntitiesComponent),
        component: (AuthContainerComponent),
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./components/auth/auth.module').then(m => m.AuthModule)
            }
        ]
    },
    {
        path: '',
        redirectTo: 'auth/login',
        pathMatch: 'full'
        // component: DashboardContainerComponent,
        // children: [
        //     {
        //         path: 'products',
        //         redirectTo: 'auth',
        //         // loadChildren: () =>
        //         //     import('./components/products/products.module').then(m => m.ProductsModule)
        //     },
        //     {
        //         path: 'transforming',
        //         loadChildren: () =>
        //             import('./components/transform/transform.module').then(m => m.TransformModule)
        //     },
        //     {
        //         path: 'managing',
        //         loadChildren: () =>
        //             import('./components/manage/manage.module').then(m => m.ManageModule)
        //     },
        //     {
        //         path: 'contact-us',
        //         loadChildren: () =>
        //             import('./components/contact-us/contact-us.module').then(m => m.ContactUsModule)
        //     },
        //     {
        //         path: 'pric',
        //         loadChildren: () =>
        //             import('./components/pricing/pricing.module').then(m => m.PricingModule)
        //     },
        //     {
        //         path: 'about-us',
        //         loadChildren: () =>
        //             import('./components/about-us/about-us.module').then(m => m.AboutUsModule)
        //     },
        //     {
        //         path: 'careers',
        //         loadChildren: () =>
        //             import('./components/careers/careers.module').then(m => m.CareersModule)
        //     },
        //     {
        //         path: 'terms-and-conditions',
        //         loadChildren: () =>
        //             import('./components/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
        //     },
        //     {
        //         path: '',
        //         loadChildren: () =>
        //             import('./components/home/home.module').then(m => m.HomeModule)
        //     }
        // ]
    },
    {
        path: '404',
        component: NotFoundComponent
        // loadChildren: () =>
        //     import('./components/home/home.module').then(m => m.HomeModule)
    },
    {
        path: '**',
        component: NotFoundComponent
        // loadChildren: () =>
        //     import('./components/home/home.module').then(m => m.HomeModule)
    },
    /* {
         path: "home",
         component: DashboardContainerComponent,
         children: [

             {
                 path: "products",
                 loadChildren: () =>
                     import('./components/products/products.module').then(m => m.ProductsModule)
             },
             {
                 path: "contact-us",
                 loadChildren: () =>
                     import('./components/contact-us/contact-us.module').then(m => m.ContactUsModule)
             },
             {
                 path: "pricing",
                 loadChildren: () =>
                     import('./components/pricing/pricing.module').then(m => m.PricingModule)
             },
             {
                 path: "about-us",
                 loadChildren: () =>
                     import('./components/about-us/about-us.module').then(m => m.AboutUsModule)
             },
             {
                 path: "**",
                 loadChildren: () =>
                     import('./components/home/home.module').then(m => m.HomeModule)
             }
         ]
     }*/
];

export const routing: ModuleWithProviders = RouterModule.forRoot(
    routes,
    {
        preloadingStrategy: PreloadAllModules,
        useHash: false,
        enableTracing: false,
        scrollPositionRestoration: 'top',
        onSameUrlNavigation: 'reload'
    }
);
